import type { FC } from "react";
import { Navigate } from "react-router-dom";

import { useMembership } from "@/hooks/use-membership";
import { OrganizationRole } from "gitpod-next-api/gitpod/v1/organization_pb";

/**
 * Redirects to the first visible org settings page:
 * manage-organization for admins, members for non-admins.
 */
export const SettingsRedirect: FC = () => {
    const { membership, isPending: membershipPending } = useMembership();

    if (membershipPending) {
        return null;
    }

    const isAdmin = membership?.userRole === OrganizationRole.ADMIN;
    const to = isAdmin ? "/settings/manage-organization" : "/settings/members";

    return <Navigate to={to} replace />;
};
